import { Aka, Ssn, SurveyQuery } from '@surveycake/logic-engine';
import { Exception } from 'app/core/status';
import { parse } from 'qs';

const utmKeys = [
  'utm_source',
  'utm_medium',
  'utm_term',
  'utm_content',
  'utm_campaign'
];

/**
 * To get the query object from query string.
 *
 * @todo Should be serialized by SurveyConfigEngine. Please see the roadmap of `logic-engine`.
 */
export function initialQuery() {
  if (!window.location.search) {
    return;
  }

  try {
    const parsed = parse(window.location.search, { ignoreQueryPrefix: true });
    const query = {} as SurveyQuery;
    const ssn = {} as Ssn;
    const aka = {} as Aka;

    Object.keys(parsed).forEach(key => {
      const value: string | string[] = parsed[key];
      if (utmKeys.includes(key)) {
        (query as any)[key] = (value as string) || 'unknown';
      } else if (key.startsWith('ssn')) {
        const sn = parseInt(key.replace('ssn', ''), 10);
        ssn[sn] = typeof value === 'string' ? [value] : value;
      } else if (key.startsWith('aka_')) {
        const akaName = key.replace('aka_', '');
        aka[akaName] = (typeof value === 'string' ? [value] : value).map(
          (v: string) => v.replace('aka_', '')
        );
      } else {
        (query as any)[key] = value as string;
      }
    });

    return { ...query, ssn, aka };
  } catch (error) {
    throw new Exception('NOT_FOUND');
  }
}
